import { withAuthProvider } from "../../../../lib/auth";
import { compose } from "recompose";
import JobApplicationView from "./view";
import withFormState from "./state";
import withFormValidation from "./validation";
import { withRouter } from "react-router";
import withFormHandlers from "./handlers";

const JobApplicationForm = compose(
  withFormState,
  withFormValidation,
  withRouter,
  withFormHandlers,
  withAuthProvider,
)(JobApplicationView);

JobApplicationForm.displayName = "JobApplicationForm";

export default JobApplicationForm;
